import React from "react";

const WaTeamAws = () => {
  return <div>WaTeamAws</div>;
};

export default WaTeamAws;
